import { defineStore } from 'pinia';
import CommonService from '@/services/common';

export const useAutoLoadStore = defineStore('autoLoadStore', {
	state: () => ({
		countryCodes: {
			list: [], // Danh sách dữ liệu ban đầu
			loader: CommonService.getCountryCodes, // Hàm gọi API để lấy dữ liệu và gán vào list
			status: null, // Trạng thái tải: null, "loading", "success", "error"
			clearRoute: 'Home', // Route làm mới danh sách khi chuyển đến
		},
		countryCurrent: {
			list: {},
			loader: CommonService.getCountryCurrent,
			status: null,
			clearRoute: 'Home',
		},
		constants: {
			list: {},
			loader: CommonService.getConstants,
			status: null,
			clearRoute: 'Home',
		},
	}),

	getters: {
		getList: (state) => (name) => {
			if (!state[name]) {
				console.error(`List ${name} not found in autoLoadStore`);
				return [];
			}
			const { list, status } = state[name];
			if (!status || status === 'error') {
				this.loadData(name); // Gọi hàm loadData nếu cần tải lại
			}
			return list;
		},
	},

	actions: {
		// Hàm tái sử dụng để xử lý loader
		loadData(name) {
			const { loader } = this.$state[name];
			this.$state[name].status = 'loading'; // Đặt trạng thái loading
			loader()
				.then(({ data }) => {
					this.$state[name].list = data; // Cập nhật danh sách
					this.$state[name].status = 'success'; // Thành công
				})
				.catch((error) => {
					this.$state[name].status = 'error'; // Lỗi
					console.error(`Error loading ${name}:`, error); // Ghi log lỗi
				});
		},

		// Tải dữ liệu khi khởi động
		started() {
			Object.keys(this.$state).forEach((name) => {
				const { status } = this.$state[name];
				if (!status || status === 'error') {
					this.loadData(name); // Sử dụng loadData
				}
			});
		},

		// Xóa và tải lại danh sách khi thay đổi route
		clearListOnRoute(routeName) {
			Object.entries(this.$state).forEach(([name, { clearRoute }]) => {
				if (clearRoute === routeName) {
					this.$state[name] = { ...this.$state[name], list: [], status: null };
					this.loadData(name); // Sử dụng loadData
				}
			});
		},
	},
});
